import type { ReactNode } from 'react';

import { FilterFormLayout } from 'widgets';

import { useHouseholdFiltersContext } from './HouseholdFiltersContext';
import { HouseholdMultiFilter } from './HouseholdMultiFilter';

export const HouseholdFilterForm = ({
    centerContent,
    count,
    countLabel,
    rightActions,
}: {
    centerContent?: ReactNode;
    count?: number;
    countLabel?: string;
    rightActions?: ReactNode;
}) => {
    const { isFilterActive, resetFilters } = useHouseholdFiltersContext();

    return (
        <FilterFormLayout
            centerContent={centerContent}
            count={count}
            countLabel={countLabel}
            isFilterActive={isFilterActive}
            onResetFilters={() => resetFilters()}
            showResetFilters={false}
            filterButtons={<HouseholdMultiFilter />}
            filterLabels={null}
            rightActions={rightActions}
        />
    );
};
